import { forwardRef } from "react";
import { classNames } from "../../utils/classNames";

export const Content = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div">
>(function Content({ children, className, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={classNames(
        "bg-primary p-6 md:p-10 rounded-2xl shadow-inner",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
});
